import axios from 'axios';
import { newApiBaseUrl } from '../../axiosInstance';


export const GetPriceList = async (gtin, retailer = null, branch = null, sort = "timestamp:desc", limit = 1) => {
    try {
        const params = { gtin, sort, limit };
        if (retailer) params.retailer = retailer;
        if (branch) params.branch = branch;

        const response = await axios.get(`${newApiBaseUrl}/prices`, {
            params,
            headers: {
                // 'Authorization': `Bearer ${localStorage.token}`,
                'Content-Type': 'application/json'
            },
        });

        return response.data;
    } catch (error) {
        console.error("Error fetching price list:", error);
        throw error;
    }
};
